import { render, staticRenderFns } from "./PackageDetail.vue?vue&type=template&id=1e2f5640&scoped=true"
import script from "./PackageDetail.vue?vue&type=script&lang=js"
export * from "./PackageDetail.vue?vue&type=script&lang=js"
import style0 from "./PackageDetail.vue?vue&type=style&index=0&id=1e2f5640&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f5640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e2f5640')) {
      api.createRecord('1e2f5640', component.options)
    } else {
      api.reload('1e2f5640', component.options)
    }
    module.hot.accept("./PackageDetail.vue?vue&type=template&id=1e2f5640&scoped=true", function () {
      api.rerender('1e2f5640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/coupon/package/modules/PackageDetail.vue"
export default component.exports